<template>
<div class="component">
    <div class="tabs" v-if="$showLocalisation">
        <ul>
            <li class="" @click="activeTab='de'" :class="{'is-active':activeTab=='de'}"><a>Deutsch</a></li>
            <li @click="activeTab='en'" :class="{'is-active':activeTab=='en'}"><a>English</a></li>
        </ul>
    </div>

    <div class="newMessageButtonContainer">
        <router-link class="button is-info is-large" :to="'/message/create'">{{$t('enaq_translation_inbox_new_button')}}</router-link>
    </div>

    <table class="table is-fullwidth">
        <thead>
            <tr>
            <th  width="10%"></th>

                <th class="has-text-centered" width="50%">{{$t('enaq_translation_inbox_title')}}</th>
                <th  width="40%">{{$t('enaq_translation_inbox_sender')}}</th>
            </tr>
        </thead>

        <tbody>
            <tr class="messageRow" v-for="message in messages" v-if="message.readedAt==null" @click="">
                <td class="newMessageIcon has-text-right"><i class="fas fa-exclamation"></i></td>
                <td class="has-text-centered newMessage" @click="openMessage(message,true)">{{shortTitle(message.title)}}</td>
                <td @click="$router.push({ name: 'user', params: { id: message.author.id } })">
                    <span class="authorImageContainer" >

                    <img class="authorImage" :src="$storageURL+'/avatars/'+message.author.avatar" />
                    </span>
                    <span class="authorName">{{message.author.name}}, {{message.author.firstname}}</span>
                </td>
            </tr>

            <tr class="messageRow" v-for="message in messages" v-if="message.readedAt!=null" >
            <td></td>
                <td class="has-text-centered" @click="openMessage(message,false)">{{shortTitle(message.title)}}</td>
                <td @click="$router.push({ name: 'user', params: { id: message.author.id } })">
                    <div class="authorImageContainer" >
                    <img class="authorImage" :src="$storageURL+'/avatars/'+message.author.avatar" />
                    </div>
                    <div class="authorName">{{message.author.name}}, {{message.author.firstname}}</div>
                </td>
            </tr>
        </tbody>

    </table>

    <message :messageId="selectedMessage" v-if="selectedMessage>=0" @close="selectedMessage=-1"></message>
</div>
</template>

<script>
import message from '@/components/message.vue'
export default {
    name: 'inbox',
    props: [],
    components: {
        message
    },
    mounted: function () {
        this.getMessages();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            activeTab: "de",
            messages: [],
            selectedMessage: -1,
        }
    },
    methods: {
        getMessages() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/message/own", {
                headers: headerData
            }).then(function (response) {
                this.messages = response.data.messages
            }.bind(this))
        },
        openMessage(message, newMessage) {
            if(newMessage){
                this.$store.commit('setNewMessage', this.$store.getters.getNewMessageCount-1);
                
            }
            this.selectedMessage = message.id
            message.readedAt = new Date();
        },
        shortTitle(title){
            if(title.length<=30){
                return title
            }
            return title.substring(0,30)+"..."
        }
    },
    computed: {},
}
</script>

<style scoped>
.messageRow {
    cursor: pointer;
}
.newMessage{
    color:#004684;
    font-weight:bolder;
}
.newMessageButtonContainer {
    text-align: right;
    padding-right: 10%;
    padding-top: 10px;
}
/* 
.authorImage {
 max-height: inherit;
    max-width: inherit;    
    vertical-align: text-bottom;
    background:red;

}

.authorImageContainer {
    width: 30px;
    max-height: 30px;
    height:30px;
    overflow: hidden;
    border-radius: 30px;

}
*/
.authorImage {
    display: inline;
    margin: 0 auto;
    height: 100%;
  width: 100%;
  object-fit: contain;
    vertical-align: text-bottom;


}

.newMessageIcon{
    color:green;
    font-size:1.5em;
    font-weight:bolder;
}

.authorImageContainer {
        vertical-align: text-bottom;

    width: 40px;
    height: 40px;
      display: inline-block;
    position: relative;
    overflow: hidden;
    border-radius: 45%;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,70,132,1);
-moz-box-shadow: 0px 0px 4px 0px rgba(0,70,132,1);
box-shadow: 0px 0px 4px 0px rgba(0,70,132,1);

}

.authorName {
    padding-left: 10px;
    display: inline-block;
    height: 30px;
    vertical-align: text-bottom;
}

@media screen and (max-width: 600px) {
    .authorImageContainer{display:none;}
    .newMessageButtonContainer{
        text-align:center;
        padding-right:0;
        margin-bottom:20px;
    }
}
</style>
